import { useContentfulPage } from "../context/ContentfulPageContext";

export const VariantTitle = ({ subtitle, title, isNested = false, sectionId = '', description = "", parsedClasses = "" }) => {
	const { getContentBlockStyles} = useContentfulPage();
	const blockStyles = getContentBlockStyles(sectionId);
	return (
		<div className={`flex flex-col w-[100%] ${parsedClasses}`}>
			{subtitle && <p className={blockStyles?.textColor || `text-is2-gray-300`}>{subtitle}</p>}
			<h2 className={` p-0 m-0 ${isNested && "!text-xl" } ${blockStyles?.textColor || ''}`}>{title}</h2>
			{description}
		</div>
	);
};
